var _defs, _path, _polygon, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDbs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.73,237.9A15.27,15.27,0,0,1,45.5,222.67V67.8L102,17.9h93.26A15.28,15.28,0,0,1,210.5,33.13V222.87a15.23,15.23,0,0,1-15.25,15.23Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "102.01 17.9 101.77 67.72 45.5 67.8 102.01 17.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.34,96.59c-.63.28-1.26.58-1.89.88a48.9,48.9,0,0,0-22.69,23.17A121.4,121.4,0,0,0,79,145.47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178,156.78a49.3,49.3,0,0,0-26.1-59.92c-1.08-.49-1.75-.77-2.42-1a49.09,49.09,0,0,0-28.23-2.42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.71,124.21c-.29.53-.56,1.08-.82,1.63a116.65,116.65,0,0,0-9.08,36.48"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.75,105a37.1,37.1,0,0,0-31.82,10.66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.35,175.72c-1.25-7.41,1.19-15.84,2.58-19.17A36.91,36.91,0,0,0,146.75,108"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.67,151.59a96.6,96.6,0,0,0-1.17,32.53"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.28,127.22a24.34,24.34,0,0,0-9.69-8c-.45-.21-.81-.36-1.17-.5A24.63,24.63,0,0,0,109,131.05a81.55,81.55,0,0,0-3.68,9.92"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.6,187.48c-8.73-15.42,0-35.66.07-35.86a24.33,24.33,0,0,0,1.6-15.45"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.45,146.61a12.29,12.29,0,0,0-22.29-10.36c-.62,1.34-13.63,29.81-3.42,58.88"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.91,193.53c-7.49-13.2-5.84-28.12-3.53-37.52"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.29,141.46s-14.47,31,.93,58.13"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbs);
export default __webpack_public_path__ + "static/media/dbs.483c07b379b383f9effd401d9bbded7a.svg";
export { ForwardRef as ReactComponent };